<section class="sold-units">
  <h2 id="product-sold-units-title" class="container">Unidades Vendidas</h2>

  <div class="scrollable">
    <table class="table">
      <caption>Tabela de unidades vendidas</caption>

      <tr>
        <th id="variation">Variação</th>
        <th id="unity">Unidade</th>
        <th id="price">Preço</th>
        <th id="value">Valor m²</th>
        <th id="area">Área</th>
        <th id="bedrooms">Quartos/Banheiros</th>
        <th id="sale-date">Data de venda</th>
      </tr>

      <tr *ngFor="let item of data.sold_units">
        <td class="text-red">
          <ng-container *ngIf="item.variation !== undefined">
            {{item.variation}}%
          </ng-container>
        </td>
        <td>
          <ng-container *ngIf="item.unit_number !== undefined">
            {{item.unit_number}}
          </ng-container>
        </td>
        <td>
          <ng-container *ngIf="item.price !== undefined">
            {{item.price.currency}} {{item.price.value | number}}
          </ng-container>
        </td>
        <td>
          <ng-container *ngIf="item.value_per_square_meter !== undefined">
            {{item.value_per_square_meter.currency}} {{item.value_per_square_meter.value}}
          </ng-container>
        </td>
        <td>
          <ng-container *ngIf="item.area !== undefined">
            {{item.area}}
          </ng-container>
        </td>
        <td>
          <ng-container *ngIf="item.bedroom !== undefined">
            {{item.bedroom}}/{{item.bathroom}}
          </ng-container>
        </td>
        <td>
          <ng-container *ngIf="item.sale_date !== undefined">
            {{item.sale_date | date:'dd/MM/yy'}}
          </ng-container>
        </td>
      </tr>

    </table>
  </div>

</section>